import React, { useContext, useState } from "react";
import { isEmptyValue, isValidInput } from "utils/forms/forms";
import { moveDateValidation } from "utils/validations/moveDateValidation";

import content from "./static/content.json";
const {
  addressFinderError,
  dateInvalidError,
  dateRequiredError,
  termsAndConditionsError,
} = content;

type MovingHouseContext = {
  address: FormField;
  isFormValid: boolean;
  moveDate: FormField;
  medicallyDependent: FormField;
  termsAndConditions: FormField;
  userPlan: FormField;
};

const MovingHouseFormContext = React.createContext<MovingHouseContext>(
  {} as MovingHouseContext,
);

export const useMovingHouseFormContext = () =>
  useContext(MovingHouseFormContext);

const initialFormFieldState = {
  value: "",
  isRequired: true,
  isValid: false,
  error: "",
};

export const MovingHouseFormContextProvider = ({ children }) => {
  const [address, setAddress] = useState({
    ...initialFormFieldState,
    value: {},
  });
  const [moveDate, setMoveDate] = useState(initialFormFieldState);
  const [medicallyDependent, setMedicallyDependent] = useState({
    ...initialFormFieldState,
    value: {},
  });
  const [userPlan, setUserPlan] = useState({
    ...initialFormFieldState,
    value: {},
  });
  const [termsAndConditions, setTermsAndConditions] = useState({
    ...initialFormFieldState,
    value: false,
  });

  const setValueAddress = (value: CustomerAddress | null) => {
    const isValid = !isEmptyValue(value);
    setAddress((prev) => ({
      ...prev,
      isValid,
      error: isValid ? "" : addressFinderError,
      value,
    }));
  };

  const setValueMoveDate = (value: string) => {
    const isSpecified = !isEmptyValue(value);
    const isValid = isSpecified && moveDateValidation(value);
    let error = "";
    error = isValid ? "" : dateInvalidError;
    error = isSpecified ? error : dateRequiredError;
    setMoveDate((prev) => ({
      ...prev,
      isValid: isSpecified && isValid,
      error,
      value,
    }));
  };

  const setValueMedicallyDependent = (value: boolean) => {
    setMedicallyDependent((prev) => ({
      ...prev,
      isValid: true,
      error: "",
      value,
    }));
  };

  const setValueUserPlan = (value: boolean) => {
    setUserPlan((prev) => ({
      ...prev,
      isValid: true,
      error: "",
      value,
    }));
  };

  const setValueTermsAndConditions = () => {
    setTermsAndConditions((prev) => {
      const value = !prev.value;
      return {
        ...prev,
        isValid: value,
        error: value ? "" : termsAndConditionsError,
        value,
      };
    });
  };

  const allInputsValid = [
    isValidInput(address),
    isValidInput(moveDate),
    isValidInput(medicallyDependent),
    isValidInput(userPlan),
    isValidInput(termsAndConditions),
  ].every(Boolean);

  return (
    <MovingHouseFormContext.Provider
      value={{
        address: {
          fieldValue: address,
          handleOnChange: setValueAddress,
        },
        moveDate: {
          fieldValue: moveDate,
          handleOnChange: setValueMoveDate,
        },
        medicallyDependent: {
          fieldValue: medicallyDependent,
          handleOnChange: setValueMedicallyDependent,
        },
        termsAndConditions: {
          fieldValue: termsAndConditions,
          handleOnChange: setValueTermsAndConditions,
        },
        userPlan: {
          fieldValue: userPlan,
          handleOnChange: setValueUserPlan,
        },
        isFormValid: allInputsValid,
      }}
    >
      {children}
    </MovingHouseFormContext.Provider>
  );
};
